module.exports = __webpack_public_path__ + "static/img/animales_31.fd6383bb.jpeg";